import { DailyJournalsRightType, FinanceAndAccountRights, SourceTypeProject } from "@/enums/enums";
import { i18n } from "@/i18n";
import router from "@/router";
export function UserId() {
  const sessionUserId: any = sessionStorage.getItem("ui");
  return sessionUserId;
}
export function MerchantId() {
  const sessionMerchantId: any = sessionStorage.getItem("mi");
  return sessionMerchantId;
}
export function AccessToken() {
  return sessionStorage.getItem("access_token");
}
export function RefreshToken() {
  return sessionStorage.getItem("refresh_token");
}
export function SetHeaderService() {
  return {
    headers: {
      Authorization: `Bearer ${AccessToken()}`,
      source: SourceTypeProject.LineConnect,
      language: i18n.locale,
      merchantId: `${MerchantId()}`,
    },
  };
}

export function CatchAPIService(errResponse: any) {
  return errResponse;
  router.push("/error");
}
export function SetTokenData(data: any) {
  sessionStorage.setItem("access_token", data.accessToken);
  sessionStorage.setItem("refresh_token", data.refreshToken);
  sessionStorage.setItem("ui", data.userId);
  sessionStorage.setItem("mi", data.merchantId);
}
export function ConvertToManageFinanceAndJournals(role6: any) {
  const manageFinanceAndJournals = {
    FinanceAccess: { value: false },
    ChartofAccountAndGL: { value: false },
    DailyJournalsAccess: {
      value: false,
      DailyJournalsRightType: { name: i18n.t("Select_DailyJournals.All"), value: DailyJournalsRightType.All },
    },
  };

  switch (role6) {
    case FinanceAndAccountRights.All:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.All;
      break;
    case FinanceAndAccountRights.FinanceAccessOnly:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = false;
      break;
    case FinanceAndAccountRights.GLAndStatementOnly:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = false;
      break;
    case FinanceAndAccountRights.DailyJournalsAll:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.All;
      break;
    case FinanceAndAccountRights.DailyJournalsDraftOnly:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.DraftOnly;
      break;
    case FinanceAndAccountRights.DailyJournalsApproveOnly:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.ApproveOnly;
      break;
    case FinanceAndAccountRights.DailyJournalsAllAndFinance:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.All;
      break;
    case FinanceAndAccountRights.DailyJournalsDraftOnlyAndFinance:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.DraftOnly;
      break;
    case FinanceAndAccountRights.DailyJournalsApproveOnlyAndFinance:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.ApproveOnly;
      break;
    case FinanceAndAccountRights.DailyJournalsAllAndGL:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.All;
      break;
    case FinanceAndAccountRights.DailyJournalsDraftOnlyAndGL:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.DraftOnly;
      break;
    case FinanceAndAccountRights.DailyJournalsApproveOnlyAndGL:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.ApproveOnly;
      break;
    case FinanceAndAccountRights.FinanceAccountAndDailyJournalsDraftOnly:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.DraftOnly;
      break;
    case FinanceAndAccountRights.FinanceAccountAndDailyJournalsApproveOnly:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.ApproveOnly;
      break;
    case FinanceAndAccountRights.FinanceAndGL:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = false;
      break;
  }
  return manageFinanceAndJournals;
}
export function GetTimezoneOffset() {
  const date = new Date().getTimezoneOffset();
  const timezoneOffset = (date * -1) / 60;
  return timezoneOffset;
}
